import { Component } from "react";
import Renderer from "./renderer";
import { defaultProps } from "./interface";
export class Slider extends Component {
    static defaultProps = defaultProps;
    _onChange = (event) => {
        const value = event.target.value;
        const name = this.props.name;
        this.props.onInput(event, name, value);
    };
    _onAfterChange = (event) => {
        const name = this.props.name;
        this.props.onMoveEnd(event, name);
    };
    render() {
        const props = {
            className: this.props.className,
            name: this.props.name,
            min: this.props.min,
            max: this.props.max,
            value: this.props.value.toString(),
            step: this.props.step,
            disabled: this.props.disabled,
            width: this.props.width,
            orientation: this.props.orientation,
            onChange: this._onChange,
            onMouseUp: this._onAfterChange,
            onTouchEnd: this._onAfterChange,
        };
        return Renderer(props);
    }
}
//# sourceMappingURL=Slider.js.map